import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { motion } from "framer-motion";
/**
 * GNB 사용자 유형 토글 컴포넌트
 * layoutId를 사용한 슬라이딩 인디케이터 애니메이션
 */ const GNBUserTypeToggle = (param)=>{
    let { value , onChange , className , layoutIdPrefix ="gnb"  } = param;
    const options = [
        {
            value: "teacher",
            label: "선생님"
        },
        {
            value: "student",
            label: "학생"
        }
    ];
    return /*#__PURE__*/ _jsx("div", {
        role: "tablist",
        "aria-label": "사용자 유형 선택",
        className: cn("inline-flex items-center justify-center p-0.5 rounded-full bg-[#F0F1F5]", "shrink-0", className),
        children: options.map((option)=>{
            const isSelected = value === option.value;
            return /*#__PURE__*/ _jsxs("button", {
                type: "button",
                role: "tab",
                "aria-selected": isSelected,
                onClick: ()=>onChange(option.value),
                className: cn("relative inline-flex items-center justify-center gap-2.5 px-3 py-0.5 rounded-full", "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary"),
                children: [
                    isSelected && /*#__PURE__*/ _jsx(motion.div, {
                        layoutId: "".concat(layoutIdPrefix, "-toggle-indicator"),
                        className: "absolute inset-0 rounded-full bg-white shadow-sm",
                        transition: {
                            type: "spring",
                            stiffness: 500,
                            damping: 30
                        }
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        className: cn("relative z-10 text-center transition-colors duration-200", isSelected ? "text-primary" : "text-secondary"),
                        children: option.label
                    })
                ]
            }, option.value);
        })
    });
};
export default GNBUserTypeToggle;
